var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "700",
      scrollable: "",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_ClaimType_form_dilog_editClaimTransTypeTitle")
        : _vm.$t("label_essweb_ClaimType_form_dilog_viewClaimTransTypeTitle"),
      dialog: _vm.show,
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            readonly: !_vm.iSEdited,
                            maxlength: "100",
                            filled: _vm.iSEdited,
                            bindData: _vm.Data.claim_transaction_type_name,
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_claimTransTypeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.claim_transaction_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("numberInputTextFiled", {
                          attrs: {
                            maxlength: "11",
                            filled: _vm.iSEdited,
                            label: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_sequenceLabel"
                            ),
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 11]
                            ),
                            max: 1000,
                            min: 0,
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_sequenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "sequence", $$v)
                            },
                            expression: "Data.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimType_form_dilog_calculationMethodsLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            items: _vm.CalculationMethods,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_calculationMethodsLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value: _vm.Data.calculation_method,
                            callback: function ($$v) {
                              _vm.$set(_vm.Data, "calculation_method", $$v)
                            },
                            expression: "Data.calculation_method",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            maxlength: "100",
                            label: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_claimTypeCodeLabel"
                            ),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_claimTypeCodeLabel"
                            ),
                          },
                          model: {
                            value: _vm.Data.claim_transaction_type_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.Data,
                                "claim_transaction_type_code",
                                $$v
                              )
                            },
                            expression: "Data.claim_transaction_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            TrigerInit: _vm.show,
                            filled: _vm.iSEdited,
                            maxlength: "500",
                            readonly: !_vm.iSEdited,
                            bindData:
                              _vm.Data.claim_transaction_type_description,
                            label: _vm.$t(
                              "label_essweb_ClaimType_form_dialog_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.Data.claim_transaction_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimType_form_dilog_propertyGroupLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            items: _vm.ClaimTransactionTypePorpertyGroup,
                            "item-text":
                              "claim_transaction_type_property_group_name",
                            "item-value": "uuid",
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_propertyGroupLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.Data
                                .claim_transaction_type_property_group_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.Data,
                                "claim_transaction_type_property_group_uuid",
                                $$v
                              )
                            },
                            expression:
                              "Data.claim_transaction_type_property_group_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_ClaimType_form_dilog_overBalanceApprovalTemplateLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.approvalTemplates,
                            "item-text": "flow_template_name",
                            "item-value": "uuid",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            "append-icon": _vm.iSEdited
                              ? "arrow_drop_down"
                              : "",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            placeholder: _vm.$t(
                              "label_essweb_ClaimType_form_dilog_overBalanceApprovalTemplateLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.Data.over_balance_approval_flow_template_uuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.Data,
                                "over_balance_approval_flow_template_uuid",
                                $$v
                              )
                            },
                            expression:
                              "Data.over_balance_approval_flow_template_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "", cancelBtn: "" },
                  on: { save: _vm.onSave, cancel: _vm.closeDialog },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }